import { GuidePlayerContext } from '@rhg/providers/guide-player';
import { useContext } from 'react';

export function useGuidePlayer() {
    return useContext(GuidePlayerContext);
}
